import { CreateJob } from './create-job';
import { CreateJobProvider } from './create-job.provider';

export { CreateJob } from './create-job';

export const FeatureCreateJob = () => {
   return (
      <CreateJobProvider>
         <CreateJob></CreateJob>
      </CreateJobProvider>
   );
};
